import { memo, ReactElement, Suspense } from 'react';
import { lazy } from 'utils/generic/lazy';

const { AdvancedBetslipLayoutComponent } = lazy(
  () =>
    import(
      /* webpackChunkName: "advanced-betslip-layout" */ 'newelements/_Betslip/layouts/Advanced/component'
    )
);

export const AdvancedBetslipLayout = memo((): ReactElement => {
  return (
    <Suspense>
      <AdvancedBetslipLayoutComponent />
    </Suspense>
  );
});
